import './FilteredActionListLoaders-a46a8ea4.css';

var classes = {"LoadingSkeleton":"prc-FilteredActionList-LoadingSkeleton-x9WXt","LoadingSpinner":"prc-FilteredActionList-LoadingSpinner-4C8CM","LoadingSkeletonContainer":"prc-FilteredActionList-LoadingSkeletonContainer-FBx9v"};

export { classes as default };
